// Whole-number display with locale grouping; a missing value reads as 0.
export function fmt(n) { return (n ?? 0).toLocaleString(); }
